<template>
  <div class="copy-line">
    <input
      class="copy-line__input"
      aria-label="Значение для копирования"
      readonly="readonly"
      type="text"
      v-bind:value="value">
    <button
      class="copy-line__button"
      title="Скопировать значение"
      type="button"
      v-on:click="onCopy" />
  </div>
</template>

<script>
import clipboardMixin from '@/mixins/clipboardMixin';

/**
 * @description Компонент копирования строки текста.
 * @type {Vue}
 */
export default {
  methods: {
    /**
     * @description Обработать перемещение значения в буфер обмена.
     * @returns {void}
     */
    onCopy() {
      this.$emit('clipboard', this.toClipboard(this.value));
    },
  },
  mixins: [
    clipboardMixin,
  ],
  name: 'CopyLine',
  props: {
    /**
     * @description Значение.
     */
    value: {
      required: true,
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>
@use "@/scss/copy-icon";

.copy-line {
  background-color: var(--primary-background-color);
  border-radius: var(--input-border-radius);
  border: 1px solid var(--border-color);
  font-size: 21px;
  padding: 12px 45px 12px 20px;
  position: relative;
  & &__input {
    &:focus {
      outline: none;
    }
  }
  & &__button {
    @extend %copy-icon;
    height: 24px;
    position: absolute;
    right: 20px;
    width: 24px;
  }
}
</style>
